module.exports = __webpack_public_path__ + "media/backgrounds/mr-wang-Y-zq8A1G_dQ-unsplash-57a6da7f.jpg";